import React  from 'react';
import PropTypes from "prop-types";
import { Popover } from "antd";

const Legend = ({ colors, categorisedFootprint}) => {
    const legend = (color, label, footprint, tooltipText) => <div>
        <span className="legend-dot" style={{ backgroundColor: color }}></span>
        <span style={{ paddingLeft: 5 }}>
            {!tooltipText ?
            label :
                <Popover className="popover-question" content={tooltipText} title={<b>{label}</b>}>
                <a>{label}</a>
                </Popover>
        
            }
            
            : </span>{footprint.toFixed(1)}t
    </div>

    const countryEmissionsTooltip="Emissions from your country that are not directly attributable to you. This includes public services, infrastructure and exports. Engaging with political and business leaders is the best way to effect change to reduce this."

    return (<>
        <div className="chart-legend">
            {legend(colors[0], `Transport`, categorisedFootprint.Transport)}
            {legend(colors[1], `Energy`, categorisedFootprint.Energy)}
        </div>
        <div className="chart-legend">
            {legend(colors[2], `Food`, categorisedFootprint.Food)}
            {legend(colors[4], `Other`, categorisedFootprint.Other)}
        </div>
        <div className="chart-legend full-width">
            {legend(colors[3], `Country Emissions`, categorisedFootprint.CountryEmissions, countryEmissionsTooltip)}
        </div>
    </>);
}

Legend.propTypes = {
    colors: PropTypes.array.isRequired,
    footprint: PropTypes.object
};
 
export default Legend;